angular.module('app.directives').directive('appSlider', $timeout =>
    ({
        require: 'ngModel',
        restrict: 'E',
        scope: { min: '@', max: '@', range: '=' },
        template: "<div class=\"slider\"></div>",
        link(scope, element, attrs, ngModel) {
            const el = $(element).find('.slider');
            el.slider({
                min: parseInt(attrs.min, 10),
                max: parseInt(attrs.max, 10),
                range: !!attrs.range
            });
            el.bind('slide', function(event, ui) {
                ngModel.$setViewValue(ui.values || ui.value);
                return scope.$apply();
            });

            attrs.$observe('min', v => el.slider('option', 'min', parseInt(v, 10)));

            attrs.$observe('max', v => el.slider('option', 'max', parseInt(v, 10)));

            return scope.$watch((() => ngModel.$modelValue), (function(v) {
                const m = (el.slider('option', 'range') ? 'values' : 'value');
                return el.slider(m, v);
            }), true);
        }
    }));


// WEBPACK FOOTER //
// ./directives/slider.js